export enum FilterTypes {
  TextField = 'empty',
  NumberField = 'number',
  DatePicker = 'date',
  TrueFalse = 'boolean',
  NumberInterval = 'numberInterval',
}
